import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { Agent } from "src/app/agent-builder/agent-builder-services/agent.service";
import { HTTPService } from "src/app/services/http.service";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";

export interface IAConversation {
  sessionId: string;
  agent: string;
  messages: IAConverse[];
}

export interface IAConverse {
  text: string;
  chunkId?: any[];
  converseId?: string;
  role: 'user' | 'assistant';
  feedback?:string;
  feedbackMessage?:boolean;
  feedbackId?:string;
  action?: any;
  welcomeMessage?:boolean;
  lastprompt?:string;
}

export interface Answer {
    answer: string;
    citations?: any[];
    converseId?: string;
    sessionId?: string;
}

@Injectable({
  providedIn: 'root',
})

export class IAServices {
  
    sendPromptToAi(sessionId: string, agent: string, prompt: any, correlationId:string[], variables:any[]): Promise<Answer> {
        return new Promise<Answer>((resolve, reject) => {
            let body = {
                sessionId: sessionId,
                agent: agent,
                query: prompt,
                userId: this.uas.user.iduser,
                correlationId: correlationId,
                variables:variables
            };

            this.converseSubscription = this.http.post(body,'AiServices/converse',false,true,false,true).subscribe(
              {
                next: (data:any) => {
                    resolve(data as Answer);
                },
                error: (error:any) => {
                    reject(error);
                }
              });
        } );
    }

    sendPromptToAiStream(sessionId: string, agent: string, prompt: any, correlationId:string[], variables:any[]) {

        let body = {
                sessionId: sessionId,
                agent: agent,
                query: prompt,
                userId: this.uas.user.iduser,
                correlationId: JSON.stringify(correlationId),
                variables:JSON.stringify(variables)
        };
        return this.http.getEventSource('AiServices/stream',body)
    }

    constructor(private http:HTTPService, private uas:UserAuthenticationServices){}

    private converseSubject = new BehaviorSubject<IAConversation[]>([]);
    converse$ = this.converseSubject.asObservable();
    converseSubscription:Subscription = null;

    stopConverse(){
        if ( this.converseSubscription!=null ){
            this.converseSubscription.unsubscribe();
        }
    }


    updateConverseStream(sessionId: string, agent: string, newConverse: IAConverse) {
        const current = this.converseSubject.getValue();
        let converse = current.find(d => d.sessionId === sessionId && d.agent === agent);

        if (!converse) {
            converse = { sessionId, agent, messages: [] };
            current.push(converse);
        }

        const messages = converse.messages;

        // STREAM DO ASSISTENTE → atualizar última mensagem
        if (newConverse.role === 'assistant' ) {
            const last = messages[messages.length - 1];

            if (last && last.role === 'assistant') {
                last.text = newConverse.text;
            } else {
                messages.push(newConverse);
            }
        }

        
        this.converseSubject.next([...current]);
    }


    updateConverse(sessionId:string, agent:string, newConverse: IAConverse) {
        const current = this.converseSubject.getValue(); 
        let converse = current.find(d => d.sessionId === sessionId && d.agent === agent);

        if ( converse != null){
            if ( converse.messages == null){
                converse.messages = [newConverse];
            } else { 
                converse.messages.push(newConverse);
            }
        } else {
            converse = { sessionId: sessionId, agent: agent, messages: [newConverse]};
            current.push(converse);
        }
    
        this.converseSubject.next([...current]); 
    }

    loadAgentConfiguration( agent:string){

      return new Promise((resolve, reject) => {
        let body = {
            entityName: 'MKTPPPREF',
            sql: `SELECT * FROM MKTPPREF WHERE NAME='${agent}'`,
        };

        this.http.post(body,'JsonBrokerServices/findnative',false,true,false,true).subscribe({
            next: (data:any) => {
              let sqlRecords = data['SQL'] as Object[];

              if ( sqlRecords != null && sqlRecords.length > 0 ){
                  const record = sqlRecords[0];
                  let preference = JSON.parse( record['TEXT'] );
                  resolve(preference['welcomeMessage']);
              }
              resolve(null);
            },
            error: (error:any) => {
                reject(error);
            }
        })
      });
    }

    convertTextToHtml(text: string): string {
      if (!text) return '';

        const withBreaks = text.replace(/\n/g, '<br>');

        const withLinks = withBreaks;

        return withLinks;
    }

    sendFeedBack(agent:Agent, resposta:IAConverse, sessionId:string){

        return new Promise((resolve,reject)=>{

            let fb = {
                "sessionId":sessionId,
                "converseId":resposta.converseId,
                "agent":agent._id,
                "feedback":resposta.feedbackMessage,
                "rating":resposta.feedback=='up' ? 10 : 1,
                "negative":resposta.feedback=='up'?false:true,
                "userId":this.uas.user.iduser
            }

            this.converseSubscription = this.http.post(fb,'AiServices/feedback',false,true,false,true).subscribe(
              {
                next: (data:any) => {
                    resolve(data);
                },
                error: (error:any) => {
                    reject(error);
                }
            });
        });
        
    }

}